import React from 'react';
import t from '../Translation/Translation';
import { Avatar, ThemeSwitcher, checkDarkTheme } from 'citric_components';
import { IonContent, IonHeader, IonMenu, IonTitle, IonToolbar, IonList, IonItem, IonLabel, IonFooter } from '@ionic/react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette } from '@fortawesome/free-solid-svg-icons';
import Logo from '../../images/menu_logo.png';
import LogoW from '../../images/menu_logo_w.png';
import conf from '../../config.json';

import TranslationSelector from '../Translation/TranslationSelector2';
import { Row, Col } from 'react-bootstrap';
import { goToWebCitric } from '../Util/Util';

export default function Menubar(props) {
    const isDarkTheme = checkDarkTheme();

    return (
        <IonMenu contentId={props.contentId}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>
                        <Avatar name={props.token.name.charAt(0).toUpperCase()}/><IonLabel className="ion-padding">{props.token.name}</IonLabel>
                    </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <div className='ps-2'><TranslationSelector current={props.lang} func={props.setLang}/></div>
                <div className='ps-2'><ThemeSwitcher classes="d-flex align-items-center pointer" text={<span>{t('toogle_theme')}</span>} icon={<div className="d-inline-flex me-3"><FontAwesomeIcon className='theme_btn' icon={faPalette} /></div>}/></div>
                <IonList>
                    <IonItem className="pointer" onClick={() => window.location.href = "mailto:soporte@citricdata.com?subject=Dashboard"}>
                        <IonLabel>{t('contact_us')}</IonLabel>
                    </IonItem>
                    <IonItem className="pointer" onClick={() => props.setToken(null)}>
                        <IonLabel>{t('close_session')}</IonLabel>
                    </IonItem>
                </IonList>
            </IonContent>
            <IonFooter>
                    <IonToolbar>
                        <IonTitle>
                            <Row className="d-flex align-items-end h-100">
                                <Col md="9">
                                    <div className="brandLogo pointer" onClick={() => goToWebCitric(props.lang)}></div>
                                </Col>
                                <Col md="3" className="d-flex align-items-center">
                                    <div className="ion-text-end">
                                        <IonLabel color="medium">{"v" + conf.version}</IonLabel>
                                    </div>
                                </Col>
                            </Row>
                        </IonTitle>
                    </IonToolbar>
                </IonFooter>
        </IonMenu>
    );
}
